<div class="publication-mode-container">
  <div class="mode-title">
    {{ 'COMMON.FIELDS.PUBLICATION-MODE' |  translate }}
  </div>
  <div class="publication-mode-selector">
    <dx-radio-group
      [(value)]="mode"
      [items]="modes"
      valueExpr="value"
      layout="vertical"
      itemTemplate="modeTemplate"
      [readOnly]="isViewMode"
      (onValueChanged)="onModeChanged($event)"
    >
      <div *dxTemplate="let item of 'modeTemplate'">
        <div class="mode-card">
          <div class="mode-card-content">
            <div class="mode-card-title-container">
              <div class="mode-card-title">
                <div class="mode-card-icon">
                  <i
                    class="dx-icon dx-svg-icon"
                    [innerHTML]="item.icon">
                  </i>
                </div>
                {{ item.title }}
              </div>

              <span *ngIf="item.required" class="mode-card-badge">
                {{ 'COMMON.CATEGORY-REQUIRED' | translate }}
              </span>
            </div>

            <div class="mode-card-description">
              {{ item.description }}
            </div>
          </div>
        </div>
      </div>
    </dx-radio-group>
  </div>
</div>